<template>
  <div>
    <StatusBadge
      :status="radiusActive.status"
      :text="radiusActive.label"
    />
  </div>
</template>

<script>
import { StatusBadge } from '@jumpcloud/ui-components';
import RadiusMFAValues from 'client/util/Constants/RadiusMFA';

export default {
  name: 'RadiusMFAStatusBadge',

  components: { StatusBadge },

  props: {
    item: {
      default: () => ({ item: { mfa: RadiusMFAValues.disabled } }),
      type: Object,
    },
  },

  computed: {
    radiusActive() {
      const isMfaDisabled = !this.item.mfa || this.item.mfa === RadiusMFAValues.disabled;
      const activeState = {
        label: 'Required',
        status: 'success',
      };

      const inactiveState = {
        label: 'Not Required',
        status: 'inactive',
      };

      return isMfaDisabled ? inactiveState : activeState;
    },
  },
};
</script>
